<div class="flex items-center justify-center min-h-screen bg-gray-100 min-w-screen">
    <div class="text-center p-6 bg-white shadow-md rounded-lg">
      <h1 class="text-6xl font-bold text-red-600">403</h1>
      <h2 class="text-2xl font-semibold mt-4 text-gray-800">Access Denied</h2>
      <p class="text-gray-600 mt-2">
        You do not have the necessary permissions to view this page.
      </p>
      <div class="mt-6">
        <a
          [href]="redirectUri"
          class="px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition duration-200"
        >
          Go to Home
        </a>
      </div>
    </div>
  </div>
  